import { render, staticRenderFns } from "./AnexosGestaoDlg.vue?vue&type=template&id=414ffcfc"
import script from "./AnexosGestaoDlg.vue?vue&type=script&lang=js"
export * from "./AnexosGestaoDlg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports